import { useQuery } from "@tanstack/react-query";

import { suggestItems, type SuggestField } from "../api/items.js";
import { useApiClient } from "../api/ApiClientContext.js";
import { useDebouncedValue } from "./useDebouncedValue.js";

const DEBOUNCE_MS = 200;
const MIN_QUERY_LENGTH = 1;

/** Debounced `GET /api/items/suggestions` for one autocomplete field. */
export function useSuggestions(field: SuggestField, query: string): string[] {
  const client = useApiClient();
  const debounced = useDebouncedValue(query.trim(), DEBOUNCE_MS);

  const { data } = useQuery({
    queryKey: ["suggestions", field, debounced],
    queryFn: () => suggestItems(client, field, debounced),
    enabled: debounced.length >= MIN_QUERY_LENGTH,
    placeholderData: (previous) => previous,
  });

  return data?.suggestions ?? [];
}
